import { render } from "./VpnCustomerGateway.vue?vue&type=template&id=944c7f22&scoped=true"
import script from "./VpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./VpnCustomerGateway.vue?vue&type=script&lang=js"

import "./VpnCustomerGateway.vue?vue&type=style&index=0&id=944c7f22&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944c7f22"]])

export default __exports__